import merge from 'lodash-es/merge';
import isEqual from 'lodash-es/isEqual';
import isFunction from 'lodash-es/isFunction';
import isString from 'lodash-es/isString';
import isObject from 'lodash-es/isObject';
import pick from 'lodash-es/pick';
import get from 'lodash-es/get';
import cloneDeep from 'lodash-es/cloneDeep';
import 'nouislider/distribute/nouislider.css';
import updateStyle from '../css/updateStyle';
import lookAndFeel from '../lookAndFeel';
import updateStyleByRef from '../css/updateStyleByRef';
import updateClass from '../css/updateClass';
import noUiSlider from 'nouislider';
import uniqueId from '../uniqueId';
import frameProps from '../css/frameProps';
import defaults from './range.defaults';
import getDisabledStyle from '../css/disabledStyle';
import Control from './control';

function updateRangeClasses(control, options) {
  const design = get(control,['options','lookAndFeel','controlsDesign'],'classic');
  let normal = get(options, 'style.normal');
  let scheme = lookAndFeel(options.lookAndFeel, normal.height);
  let CSS = updateStyleByRef(merge(cloneDeep(defaults.cssClass), design=='flat'?defaults.cssClassFlat:[]), scheme);

  if (isEqual(control.CSS, CSS)) {
    return;
  }

  control.CSS = CSS;
  control.styleSheet = updateClass(control.styleSheet, CSS, '#' + control.id);
}

export default class Range extends Control {
  constructor(instance, path, nicePath) {
    super(instance, path, nicePath);

    // Override value API to add valueFormatter support
    this.addApi(
      this,
      'value',
      () =>
        this._checkDataOption(
          'value',
          this._controlOptions.value !== undefined
            ? (this._controlOptions.value && typeof this._controlOptions.value === 'object' && !Array.isArray(this._controlOptions.value))
              ? this._controlOptions.value.defaultValue
              : this._controlOptions.value
            : undefined
        ),
      {
        formatter: 'valueFormatter',
        persistent: !this.isLayoutMode && !this.isDesignMode,
        twoWay: true,
        onChange: (value, oldValue) => this.raiseEvent('change', { value, oldValue })
      }
    );
  }

  renderElement() {
    const control = this;
    const options = this._controlOptions;
    const instance = this.instance;
    const path = this.path;

    if (options.data && options.data.options !== undefined) {
      const [min, max] = (options.data.options + '').split(',');
      options.range = { min, max };
    }

    var sliderOptions = merge({}, defaults.options, pick(options, defaults.sliderKeys));
    sliderOptions.start = control.value !== undefined ? control.value : sliderOptions.start;
    defaults.normalize(sliderOptions);

    if (!control.el) {
      control.el = defaults.createElement(control);
      if(!control.id){
        control.id = uniqueId(control.el, 'recharts-range-', Range);
        control.styleSheet = 'css-' + control.id;
      }else{
        control.el.setAttribute('id',control.id);
      }

      options.documentElement = window.document;
      // console.log({ sliderOptions });
      control.range = noUiSlider.create(control.el, sliderOptions);
      if (!control.isLayoutMode) {
        control.range.on('change', (values, handle, unencoded, tap, positions) => {
          control.value = unencoded;
          // console.log('range change', unencoded);
          //updateDataSourceParameter(control, options, instance);

          if (options.trigger) {
            if (!isFunction(options.trigger)) {
              console.error("range's change trigger should be a function", options.trigger);
            } else {
              options.trigger.apply(this, [options, instance, control, path]);
            }
          }

          if (options.event) {
            if (!isString(options.event)) {
              console.error("range's change event should be a string", options.event);
            } else {
              instance.fire(
                options.event,
                pick(options, ['name', 'options', 'type', 'gridElement']),
                control,
                path
              );
            }
          }

          control.doResetReload();
        });
      } else {
        control.el.getElementsByClassName('noUi-base')[0].style.pointerEvents = 'none';
      }
    }

    updateRangeClasses(control, options);
    //var bodyEl = control.el.getElementsByClassName('body')[0];
    var stylePatch = {};
    merge(stylePatch, defaults.cssStyle.normal);

    if (options.style && options.style.normal) {
      merge(stylePatch, pick(options.style.normal, [...frameProps,'pointerEvents']));
    }

    merge(stylePatch, control.frameStyle);

    if (control.disabled) {
      merge(stylePatch, getDisabledStyle());
      if (options.style && options.style.disabled) {
        merge(stylePatch, options.style.disabled);
      }

      if (control.isLayoutMode) {
        delete stylePatch.pointerEvents;
      }
    }

    let scheme = lookAndFeel(options.lookAndFeel, stylePatch.height);
    // console.log('scheme', options.lookAndFeel, scheme);
    updateStyleByRef([stylePatch], scheme);
    updateStyle(control.el, stylePatch, control.currentStyle);
    control.currentStyle = stylePatch;
    control.range.updateOptions(pick(sliderOptions, defaults.sliderUpdateKeys));
    return control.el;
  }
}
